import graphicCircuit from "../../assets/assets/images/01_graphic_circuit.svg";
import logoHub from "../../assets/assets/images/01_logo_hub.svg";
import logoNbg from "../../assets/assets/images/logo_en_white.svg";
import imageAppLayers from "../../assets/assets/images/api_thumb.svg";
import imageAppMobile from "../../assets/assets/images/mobile-phone.png";
import userAvatar from "../../assets/assets/images/avatar.png";
import cookiesIcon from "../../assets/assets/images/cookies_icon.png";
import logo from "../../assets/assets/images/logo-new.png";
import heroOverlay from "../../assets/assets/images/04_image_overlay.svg";

export const GRAPHIC_CIRCUIT = graphicCircuit;
export const LOGOHUB = logoHub;
export const LOGONBG = logoNbg;
export const IMAGE_APP_LAYERS = imageAppLayers;
export const IMAGE_APP_MOBILE = imageAppMobile;
export const USER_AVATAR = userAvatar;
export const COOKIES_ICON = cookiesIcon;
export const LOGO = logo;
export const HERO_OVERLAY = heroOverlay;